<script>
    import rpcjs from 'rpcjs';
    const {title, goto} = rpcjs.props;
    title.set('Future of Gaming');
    let mainDiv;
    let textdiv;
    import {onMount} from 'svelte';
    import {fade} from 'svelte/transition';
    /**
     * Adds two numbers together.
     */
    function onStart() {
        mainDiv.style.opacity = '100%';
        setTimeout(() => {
            if (textdiv && textdiv.style) {
                textdiv.style.zIndex = '2';
                textdiv.style.opacity = '100%';
            }
        }, 1500);
    }
    onMount(onMountFunction);
    /**
     */
    function onMountFunction() {
        setTimeout(onStart, 10);
    }
    /**
     * Adds two numbers together.
     */
    function next() {
        mainDiv.style.left = '-100vw';
        setTimeout(() => {
            goto('/futureOfGaming');
        }, 600);
    }
    /**
     * Adds two numbers together.
     * @param {int} e The first number.
     */
    function keycheck(e) {
        e.preventDefault();
        if (e.key == 'ArrowRight') {
            next();
        }
        if (e.key == 'ArrowLeft') {
            goto('/gamingImpact');
        }
    }
</script>

<svelte:window on:keyup={keycheck}/>
<section>
    <div class="main-div" in:fade bind:this={mainDiv}>
        <div class="background">
            <img
                src="../images/opusandgaming/11.png"
                alt=""
                width="100%"
                height="100%"
            />
        </div>
        <div
            class="text-div"
            bind:this={textdiv}
            role="presentation"
            on:click={next}
        >
            <img
                src="../images/opusandgaming/Subtract.png"
                alt=""
                width="100%"
                height="100%"
            />
        </div>
    </div>
    <div class="whiteDiv" />
</section>

<style>
    section {
        position: relative;
    }
    .whiteDiv {
        position: absolute;
        background-color: white;
        width: 100%;
        height: 100vh;
        overflow: hidden;
        top: 0;
    }
    .main-div {
        overflow: hidden;
        position: relative;
        transition-duration: 1s;
        z-index: 1;
        left: 0vw;
        opacity: 0;
        background-color: #101428;
        height: 100vh;
        width: 100vw;
    }
    .background {
        height: 100%;
        width: 100vw;
        opacity: 1;
        overflow: hidden;
        position: absolute;
    }
    .text-div {
        width: 100vw;
        position: absolute;
        height: 100%;
        opacity: 0;
        top: 0vw;
        z-index: -1;
        transition-duration: 1.5s;
    }
</style>
